import React, { lazy } from 'react'
import { Switch } from 'react-router-dom'
import retry from '../../retry'
import PrivateRoute from '../../components/PrivateRoute'

const  SupplementaryHoursAsStudentTicket = lazy( () =>
  retry( () => import( './SupplementaryHoursAsStudentTicket' ) )
)

const  SupplementaryHoursAsAcadDeptTicket = lazy( () =>
  retry( () => import( './SupplementaryHoursAsAcadDeptTicket' ) )
)

const SupplementaryHoursPage = lazy( () =>
  retry( () => import('./SupplementaryHoursPage') )
)

const SupplementaryHoursRedirectPage = lazy(() =>
    retry( () => import('./SupplementaryHoursRedirectPage' ) )
)

export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/protocolos/horas_complementares/new/aluno"
      permission="tickets.add_ticket"
      component={SupplementaryHoursAsStudentTicket}
    />
     <PrivateRoute
      exact
      path="/protocolos/horas_complementares/new/acad"
      permission="tickets.add_ticket"
      component={SupplementaryHoursAsAcadDeptTicket}
    />
     <PrivateRoute
      exact
      path="/protocolos/horas_complementares/new"
      component={SupplementaryHoursRedirectPage}
    />
     <PrivateRoute
      exact
      path="/protocolos/horas_complementares/:id"
      component={SupplementaryHoursPage}
    />
        {/* <PrivateRoute
      exact
      path="/protocolos/retificacao-nota/:id"
      permission="activities.view_review"
      component={GradeReviewPage}
    /> */}
  </Switch>
)
